var map = {
	"./1_Mountain_pass_violet_sand_peaks.jpeg": 81215,
	"./2_River_through_pine_forest_night.jpeg": 67837,
	"./3_Rolling_hills_with_pine_trees.jpeg": 88110,
	"./4_Celestial_body_reflected_in_water.jpeg": 99621,
	"./5_Icy_tundra_with_frozen_glaciers.jpeg": 61715,
	"./6_Pine_forest_lake_starlit_sky.jpeg": 40791,
	"./Canyon_landscape_with_cyan_water_202607090852.jpeg": 17303,
	"./Stone_gateway_in_purple_desert_202607090852.jpeg": 90303,
	"./Waterfall_cascading_down_cliffs_2K_202607090852.jpeg": 83141
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19562;